import { ENDPOINTS, QUERYKEYS, ENDPOINT_METHODS, createEndpointUrl } from './ContentApiConstants';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { localFetch } from './LocalContentFetch';
import { createFetchWrapper } from './WebUtils';
// @TEMPLATE_@MSAL - Uncomment this line to use MSAL for authentication.
import { useMsal } from '@azure/msal-react';

const DEBUG = true;

const fetchWrapper = createFetchWrapper({
    createEndpointUrl,
    localFetch,
    endpointMethods: ENDPOINT_METHODS
});

export function useGetSearches({ parameters, enabled }) {
    // @TEMPLATE_@MSAL - Uncomment this line to use MSAL for authentication.
    const msal = useMsal();

    return useQuery({
        queryKey: [
            // QueryKey goes here. See ApiConstants.js for more info.
            createEndpointUrl({ endpoint: ENDPOINTS.getSearches, parameters }),
            // Parameters go here.
            {
                ...parameters
            }],
        // Query function to make the actual query with.
        queryFn: async ({ queryKey }) => {
            if (DEBUG) console.log("Api :: getSearches");
            if (DEBUG) console.log(queryKey);

            const [_key, { ...parameters }] = queryKey;

            const result = await fetchWrapper({
                endpoint: ENDPOINTS.getSearches,
                parameters,
                msal
            });

            return { queryKey: _key, result };
        },
        // Make sure this option makes sense to your context.
        refetchOnWindowFocus: false,
        enabled
    });
}

export function useGetSearchResults({ parameters }) {
    // @TEMPLATE_@MSAL - Uncomment this line to use MSAL for authentication.
    const msal = useMsal();

    return useQuery({
        queryKey: [
            // QueryKey goes here. See ApiConstants.js for more info.
            createEndpointUrl({ endpoint: ENDPOINTS.getSearchResults, parameters }),
            // Parameters go here.
            {
                parameters
            }],
        // Query function to make the actual query with.
        queryFn: async ({ queryKey }) => {
            if (DEBUG) console.log("Api :: getSearchResults");

            const [_key, { parameters }] = queryKey;

            const result = await fetchWrapper({
                endpoint: ENDPOINTS.getSearchResults,
                parameters,
                msal
            });

            return { queryKey: _key, result };
        },
        // To disable the query, use this.
        enabled: true,
        // Make sure this option makes sense to your context.
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });
}

export function usePostSearch({ onSuccess, onError }) {
    // @TEMPLATE_@MSAL - Uncomment this line to use MSAL for authentication.
    const msal = useMsal();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (body) => {
            if (DEBUG) console.log("Api :: postSearch", body);

            const result = await fetchWrapper({
                endpoint: ENDPOINTS.postSearches,
                body,
                msal
            });

            return { result };
        },
        onSuccess: (result) => {
            if (DEBUG) console.log("MutationExample :: postSearches :: onSuccess")
            if (DEBUG) console.log(result);
            queryClient.invalidateQueries([QUERYKEYS.getSearches, {}]);
            if (onSuccess) onSuccess(result);
        },
        onError: (error) => {
            if (DEBUG) console.log("MutationExample :: postSearches :: onError")
            if (DEBUG) console.log(error);
            if (onError) onError(error);
        }
    });
}

